import { ROUTER_ORDER } from '@App/Quiz/Modules/Order/configs/const'
import { ROUTER_WORKSPACE_PLAN } from '@App/Studio/Modules/Workspace/Plan/configs/const'
import { PLAN_FEATURE, WALLET_FEATURE } from '@Core/Components/const'
import { Alert, Button, Typography } from '@mui/material'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
// import PropTypes from 'prop-types'

const AlertUpgradeFeature = ({
	slug,
	customMsg,
	className = '',
	showButton,
	onClick = () => {},
	variant,
	isButtonPricing = false
}) => {
	const { t } = useTranslation()
	const navigate = useNavigate()
	// if (!msg) return null
	const msg = useMemo(() => {
		if (customMsg) {
			return customMsg
		}
		if (slug === 'edu_token') {
			return (
				<p>
					Bạn đã sử dụng vượt quá giới hạn <span className="text-primary font-500">EduToken</span>. Hãy mua
					thêm lượt sử dụng để trải nghiệm tính năng tuyệt vời này!
				</p>
			)
		}
		if (slug === WALLET_FEATURE.create_exam.slug) {
			return t('Hết lượt tạo đề thi, vui lòng kiểm tra ví sử dụng')
		}
		if (slug === WALLET_FEATURE.create_exam.slug) {
			return t('Hết lượt tạo câu hỏi, vui lòng kiểm tra ví sử dụng')
		}
	}, [t, slug, customMsg])

	if (!msg) return null
	return (
		<Alert
			severity="error"
			// variant="filled"
			variant={variant}
			className={className}
			action={
				showButton && (
					<Button
						size="small"
						className="whitespace-nowrap"
						onClick={() => {
							onClick()
							if (isButtonPricing) {
								navigate(`/quiz/${ROUTER_ORDER.pricing}?type=feature&tab=${slug}`)
							} else {
								navigate(ROUTER_WORKSPACE_PLAN.root, { state: { slug } })
							}
						}}
					>
						{isButtonPricing ? 'Mua lượt sử dụng' : t('Xem ví sử dụng')}
					</Button>
				)
			}
		>
			{msg}
		</Alert>
	)
}

// AlertUpgradePlan.defaultProps = {}

// AlertUpgradePlan.propTypes = {}

export default React.memo(AlertUpgradeFeature)
